module.exports = __webpack_public_path__ + "img/img9.48c25ae4.svg";